import {useAuth} from '@/contexts/auth-context'
import {permissions} from '@/lib/permissions'

export interface ExecutionPermissions {
    /** Cancel a RUNNING / PENDING / CANCELLING execution. */
    canCancel: boolean
}

/**
 * Per-control permission boundaries for the ExecutionDetail page. Today the
 * page has one boundary; future work (e.g. retry, requeue) lands as
 * additional fields here — never as an aggregated `canManage`.
 */
export function useExecutionPermissions(): ExecutionPermissions {
    const {hasPermission} = useAuth()
    return {
        canCancel: hasPermission(permissions.jobs.manage),
    }
}
